export const compareDesc = (a: Date, b: Date) => {
  return a > b ? -1 : a < b ? 1 : 0
}

export const compareAsc = (a: Date, b: Date) => {
  return a < b ? -1 : a > b ? 1 : 0
}

/**
 * Returns a new date that is `days` days after the given date
 * If `days` is negative, the new date will be before the given date
 * If `days` is not an integer, it will be rounded down
 */
export const addDays = (date: Date, days: number) => {
  const copy = new Date(date.getTime())
  copy.setDate(date.getDate() + days)
  return copy
}

/**
 * Returns a new date that is `hours` hours after the given date
 * If `hours` is negative, the new date will be before the given date
 */
export const addHours = (date: Date, hours: number) => {
  const copy = new Date(date.getTime())
  copy.setHours(date.getHours() + hours)
  return copy
}

/**
 * Returns a new date that is `minutes` minutes after the given date
 * If `minutes` is negative, the new date will be before the given date
 */
export const addMinutes = (date: Date, minutes: number) => {
  const copy = new Date(date.getTime())
  copy.setMinutes(date.getMinutes() + minutes)
  return copy
}

/**
 * Returns a new date that is `seconds` seconds after the given date
 * If `seconds` is negative, the new date will be before the given date
 */
export const addSeconds = (date: Date, seconds: number) => {
  const copy = new Date(date.getTime())
  copy.setSeconds(date.getSeconds() + seconds)
  return copy
}

/**
 * Picks the latest of two dates
 */
export const pickLater = (a: Date, b?: Date) => {
  if (!b) return a
  return a > b ? a : b
}

/**
 * Picks the earliest of two dates
 */
export const pickEarlier = (a: Date, b?: Date) => {
  if (!b) return a
  return a < b ? a : b
}

/**
 * Converts a date to seconds since epoch
 */
export const toSeconds = (date: Date) => {
  return Math.floor(date.getTime() / 1000)
}

/**
 * Converts seconds since epoch to a date
 */
export const fromSeconds = (seconds: number) => {
  return new Date(seconds * 1000)
}
